import React from 'react';
import styles from './ConstructionServices.module.css';
import { FaCheckSquare } from "react-icons/fa";

const ConstructionServices = () => {
  
  const images = {
    hero: "https://images.unsplash.com/photo-1487958449943-2429e8be8625?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80",
    construction: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80",
    villa: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80",
    commercial: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80",
    designBuild: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80",
    contract: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=80"
  };

  return (
    <div className={styles.container}>
      {/* Hero Section */}
      <section className={styles.hero} style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${images.hero})` }}>
        <div className={styles.heroContent}>
          <h1 className={styles.heroTitle}>From Blueprint to Reality</h1>
          <h2 className={styles.heroSubtitle}>We Build Dreams That Last</h2>
          <p className={styles.heroText}>
            Looking to build your dream home, luxury villa, or investment property? 
            Property Plateau Realty offers turnkey construction solutions with end-to-end 
            project management — ensuring quality, transparency, and timely delivery at every stage.
          </p>
          <div className={styles.ctaButtons}>
            <button className={styles.primaryButton}>Book a Free Consultation</button>
            <button className={styles.secondaryButton}>Request a Quote</button>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Our Construction Services</h2>
        <div className={styles.servicesGrid}>
          <div className={styles.serviceCard}>
            <img src={images.construction} alt="Independent House Construction" className={styles.cardImage} />
            <div className={styles.cardContent}>
              <h3>Independent House Construction</h3>
              <p>Build your custom home on your own land — designed and executed to match your lifestyle, budget, and Vastu preferences.</p>
            </div>
          </div>

          <div className={styles.serviceCard}>
            <img src={images.villa} alt="Villa Construction" className={styles.cardImage} />
            <div className={styles.cardContent}>
              <h3>Villa Construction</h3>
              <p>From modern villas to heritage-inspired estates, we construct signature residences with luxurious layouts, quality finishes, and smart technologies.</p>
            </div>
          </div>

          <div className={styles.serviceCard}>
            <img src={images.commercial} alt="Residential & Commercial Projects" className={styles.cardImage} />
            <div className={styles.cardContent}>
              <h3>Residential & Commercial Projects</h3>
              <p>We take up G+1 to G+5 buildings, small societies, holiday homes, boutique hotels, and commercial property developments.</p>
            </div>
          </div>

          <div className={styles.serviceCard}>
            <img src={images.designBuild} alt="Design & Build Model" className={styles.cardImage} />
            <div className={styles.cardContent}>
              <h3>Design & Build Model</h3>
              <p>From architectural planning and 3D designs to construction, interiors, and handover — we offer single-window accountability for your entire project.</p>
            </div>
          </div>

          <div className={styles.serviceCard}>
            <img src={images.contract} alt="Contractual & PMC Services" className={styles.cardImage} />
            <div className={styles.cardContent}>
              <h3>Contractual & PMC Services</h3>
              <p>Already have a plan or architect? Hire us for civil contracts, labour contracts, or as your Project Management Consultant (PMC).</p>
            </div>
          </div>
        </div>
      </section>

      {/* Capabilities Section */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Our Capabilities</h2>
        <div className={styles.capabilitiesGrid}>
          <div className={styles.capabilityItem}>RCC Frame Structures</div>
          <div className={styles.capabilityItem}>MEP (Mechanical, Electrical, Plumbing) Work</div>
          <div className={styles.capabilityItem}>Brickwork, Plastering & Waterproofing</div>
          <div className={styles.capabilityItem}>Flooring, False Ceilings & Roofing</div>
          <div className={styles.capabilityItem}>Modular Kitchens & Smart Home Setup</div>
          <div className={styles.capabilityItem}>Rainwater Harvesting & Solar Integration</div>
          <div className={styles.capabilityItem}>Vastu-Compliant Layout Planning</div>
          <div className={styles.capabilityItem}>Material Procurement & Vendor Management</div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Why Build with Property Plateau?</h2>
        <div className={styles.benefitsContainer}>
          <div className={styles.benefitItem}>
            <div className={styles.checkIcon}><FaCheckSquare /></div>
            <div>
              <h3>End-to-End Execution</h3>
              <p>From approvals to handover, we manage everything — civil, electrical, plumbing, interiors, landscaping and more.</p>
            </div>
          </div>
          <div className={styles.benefitItem}>
            <div className={styles.checkIcon}><FaCheckSquare /></div>
            <div>
              <h3>Certified Engineers & Skilled Labor</h3>
              <p>On-site professionals, experienced engineers, and trained masons ensure quality and speed.</p>
            </div>
          </div>
          <div className={styles.benefitItem}>
            <div className={styles.checkIcon}><FaCheckSquare /></div>
            <div>
              <h3>Real-Time Progress Updates</h3>
              <p>Stay in control with weekly reports, photos, video walkthroughs, and a dedicated project manager.</p>
            </div>
          </div>
          <div className={styles.benefitItem}>
            <div className={styles.checkIcon}><FaCheckSquare /></div>
            <div>
              <h3>Fixed Cost, No Surprise Billing</h3>
              <p>Transparent BOQs (Bill of Quantities), milestone-based payments, and zero hidden charges.</p>
            </div>
          </div>
          <div className={styles.benefitItem}>
            <div className={styles.checkIcon}><FaCheckSquare /></div>
            <div>
              <h3>Timely Completion Guarantee</h3>
              <p>We commit to deadlines — and deliver on time.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Locations Section */}
      <section className={styles.section}>
        <h2 className={styles.sectionTitle}>Where We Build</h2>
        <div className={styles.locationsContainer}>
          <div className={styles.locationItem}>Mumbai</div>
          <div className={styles.locationItem}>Pune</div>
          <div className={styles.locationItem}>Goa</div>
          <div className={styles.locationItem}>Bangalore</div>
          <div className={styles.locationItem}>Hyderabad</div>
          <div className={styles.locationItem}>Delhi-NCR</div>
        </div>
        <p className={styles.locationNote}>Expanding across Tier 2 towns and weekend destinations</p>
      </section>

      {/* Final CTA Section */}
      <section className={styles.ctaSection}>
        <h2 className={styles.ctaTitle}>Build with Confidence — Let's Talk!</h2>
        <p className={styles.ctaText}>
          Whether you own land or are starting from scratch, let our construction experts bring your vision to life.
        </p>
        <div className={styles.ctaButtons}>
          <button className={styles.primaryButton}>Book a Free Construction Consultation</button>
          <button className={styles.secondaryButton}>Request a Quote or Site Visit</button>
        </div>
      </section>
    </div>
  );
};

export default ConstructionServices;